import React from 'react';
import Icon from 'screens/shared/icon';

export default ({ type }) => {
  const [icon, color, label] = type === 'INGRESS'
    ? ['arrow-right', '#d33', 'Ingress']
    : type === 'EGRESS'
      ? ['arrow-left', '#33d', 'Egress'] : ['arrows-alt-h', '#3d3', 'Bi-Directional'];

  return (
    <span>
      <Icon name={icon} style={{ color, fontSize: 15 }} />
      {' '}
      {label}
    </span>
  );
};
